import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import * as Highcharts from 'highcharts';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
/*import { OrderByPipe } from '@angular/common';*/

import * as _ from 'lodash';
import { TableViewService } from '../../table-view.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { Subscription } from 'rxjs';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';


@Component({
  selector: 'app-table1-component',
  templateUrl: './table1-component.component.html',
  styleUrls: ['./table1-component.component.scss']
  /*changeDetection: ChangeDetectionStrategy.OnPush*/
  // providers: [OrderByPipe],
})
export class Table1ComponentComponent implements OnInit, OnDestroy {
  jsonData: any;
  data: any;
  tableData: any;
  headers: any;
  valuesArray: any = {
    data1: [],
    data2: [],
    data3: [],
    data4: [],
    data5: [],
    data6: [],
    data7: [],
    data8: [],
    data9: [],
    data10: []

  };
  usaValues: any;
  properties: any;
  tableTitle: any;
  categories: any[] = [];
  p: number = 1; // Current page
  itemsPerPage: any; // Number of items per page
  valuesArray2: any;
  headers1: any[] = [];
  sortcolumn: string | null = null;
  headers2: any;
  start: any;
  end: any;
  significanceValue: any = "None";
  chartMainData: any = [];
  rowLayout: any = false;
  tableContent: any;
  clickCounts: { [key: string]: number } = {};
  categories2: any;
  dataCellCache: { [key: string]: any } = {}
  trans: any;
  userselectedchartdata: any;
  sorting: any = 'nosort';
  sortDirectionAsc: any = true;
  sortDirectionDesc: any = true;
  header2: any = [];
  Output: any = false;
  DefaultConfidenceLevel: any = "";
  SigValue = "None";
  ConfidenceLevel: any = "";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  selectedColumn: any = '';
  selectedascending: any = '';
  CurrentWidgetName: any = "";
  bipsDefaultColor: any = '#CAC4C4';

  @Input() popUp: any = false;
  @Input() customData: any;
  @Input() enableDataBars: boolean = false;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any = false;
  @Input() globalColorMap: { [key: string]: string } = {};
  constructor(private http: HttpClient, public tableService: TableViewService, private sanitizer: DomSanitizer, private router: Router,
    private route: ActivatedRoute, private _customSnapshotService: CustomsnapshotService, private _configService: SnapshotService) { }
  @ViewChild('customTable') customTable: ElementRef | undefined;
  @ViewChild('headerElement') headerElement: ElementRef | undefined;
  @ViewChildren('dataCell') dataCells: QueryList<ElementRef> | any;
  private subscriptions: Subscription = new Subscription();
  private originalChartMainData: any[] | null = null;
  private originalCategories: any[] | null = null;
  ngOnInit() {

    if (this.isOutput) {
      let Properties = JSON.parse(this.customData.customizationProperties);

      let Properties1;
      for (let i = 0; i < this._configService.allPageOutputDataWithoutTrend[0].length; i++) {
        if (this.customData.widget_name == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name) {
          Properties1 = JSON.parse(this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties);
        }
      }
      if (Properties1.selectedColumn != undefined) {
        Properties.selectedColumn = Properties1.selectedColumn;
      }
      if (Properties1.selectedsorting != undefined) {
        Properties.selectedsorting = Properties1.selectedsorting;
      }
      this.properties = Properties;
      // // Default hideNA to true if not explicitly set
      // if (this.properties.hideNA === undefined) {
      //   this.properties.hideNA = true;
      // }
      // Default Transpose to true if not explicitly set
      if (this.properties.Transpose1 === undefined) {
        this.properties.Transpose1 = true;
      }
      if (this.customData) {
        for (let i = 0; i < this._configService.allPageOutputDataWithoutTrend[0].length; i++) {
          if (this.customData.widget_name == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name) {
            this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties = JSON.stringify(Properties);
          }
        }
      }
      this.CurrentWidgetName = this.customData.widget_name;
      this.customData = this.customData.metric[0];
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updatesig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updatesig();
        }));
      //this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.preparemainChartData(this.customData);
            this.processAdditionalColumn();
      this.getData(this.chartMainData, 0, this.itemsPerPage, "", 'nosort');
    }
    else {
      this.http.get<any>('assets/Data/tableData.json').subscribe((data: any) => {
        this.jsonData = data;

        this.data = data[0];
        this.properties = data[0]["properties"][0];
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.properties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
          // Default Transpose to true if not explicitly set
          if (this.properties.Transpose1 === undefined) {
            this.properties.Transpose1 = true;
          }
        });
        this.tableData = data;
        this.tableContent = data;
        this.header2 = [];
        this.header2.push('Metric2');
        this.header2.push('asc');
        this.getData(this.tableData[0].data, 0, this.itemsPerPage, "", 'nosort');
        this.headers2 = this.headers.map((category: string) => {
          return { colname: category, sortorder: 'nosort' };
        });

        this.categories2 = this.categories.map((category: string) => {
          return { colname: category, sortorder: 'nosort' };
        });
        // For headers
        this.headers2 = this.headers.map((category: any, index: number) => {
          return { colname: category, sortorder: index === 1 ? 'asc' : 'nosort' };
        });

        // For categories
        this.categories2 = this.categories.map((category, index) => {
          return { colname: category, sortorder: index === 0 ? 'asc' : 'nosort' };
        });

        const allCategoryNames: string[] = this.tableData[0].data.map((item: { [x: string]: string }) => item['Category Name']);

        // Use Set to get unique category names
        const uniqueCategoryNames: string[] = Array.from(new Set(allCategoryNames));

        // Calculate the length of unique category names
        const uniqueCategoryNamesLength: number = uniqueCategoryNames.length;
        this.itemsPerPage = 10;
        this.tableTitle = this.tableData[0].title;

        this.customization(); //function to customize the table
        localStorage.setItem("properties", JSON.stringify(this.properties));
      });
    }


    const tableLeftFixedDiv = document.querySelector('.table-bodys2') as HTMLElement;
    const tableFreezFixedDiv = document.querySelector('.columnHeader') as HTMLElement;
    const scrollDiv = document.querySelector('.content') as HTMLElement;

    let isScrolling = false;

    if (scrollDiv) {
      scrollDiv.addEventListener('scroll', () => {
        if (!isScrolling) {
          isScrolling = true;

          requestAnimationFrame(() => {
            const x = scrollDiv.scrollLeft;
            const y = scrollDiv.scrollTop;
            // tableLeftFixedDiv ? tableLeftFixedDiv.style.top = -y + 'px' : '';
            // tableFreezFixedDiv ? tableFreezFixedDiv.style.left = -x + 'px' : '';
            // if (tableLeftFixedDiv) {
            //   tableLeftFixedDiv.style.top = -y + "em";
            //   tableLeftFixedDiv.offsetHeight;
            // }
            // if (tableFreezFixedDiv){
            //    tableFreezFixedDiv.style.left = -x + "em";
            //    tableFreezFixedDiv.offsetHeight;
            //   }
            if (tableFreezFixedDiv) {
              // tableFreezFixedDiv.style.willChange = "transform";
              // tableFreezFixedDiv.style.setProperty('transform', `translateX(${-x}px) translateY(0)`, 'important');
              // tableFreezFixedDiv.style.display = "none";
              tableFreezFixedDiv.style.left = -x + 'px';
            }
            if (tableLeftFixedDiv) {
              tableLeftFixedDiv.style.top = -y + 'px';
              //  tableLeftFixedDiv.style.transform = `translateY(${-y}px)`;
            }

            isScrolling = false;
          });
        }
      });
    }


  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['customData'] && !changes['customData'].firstChange) {
      this.properties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric[0];
         this.processAdditionalColumn();
      this.preparemainChartData(this.customData);
      this.getData(this.chartMainData, 0, this.itemsPerPage, '', 'nosort');
      this.updatesig();
    }
  }


  updatesig() {
    this.SigValue = this.significanceValue;
    this.ConfidenceLevel = this.DefaultConfidenceLevel;
    this.Sig_LowerLimt =
      this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
        ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
        : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
          ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
          : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
            : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
    this.Sig_UpperLimt =
      this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
        ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
        : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
          ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
          : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
            : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
    this.preparemainChartData(this.customData);
    this.getData(this.chartMainData, 0, this.itemsPerPage, "", 'nosort');
  }

  maxData: any = 100;
  minData: any = -100;
    additionalColumnInfos: Array<{ columnHeader: string; columnPos: number; hoverOverText: string; positiveValue?: string; negativeValue?: string; sortingOrder?: 'ascending' | 'descending' }> = [];
  renderableAdditionalColumnHeaders: Set<string> = new Set<string>();
  activeAdditionalColumnHeader: string | null = null;
  additionalColumnPopupPosition: { top: number; right: number } | null = null;

    private normalizeAdditionalColumnSortOrder(sortOrder: any): 'ascending' | 'descending' {
    const normalized = String(sortOrder || 'ascending').toLowerCase();
    return normalized === 'descending' || normalized === 'desc' ? 'descending' : 'ascending';
  }

  private normalizeFilterValue(value: any): string {
    return String(value ?? '').trim().toLowerCase();
  }

  private addValuesToSet(target: Set<string>, values: any[]): void {
    (values || []).forEach((value: any) => {
      const normalized = this.normalizeFilterValue(value);
      if (normalized) {
        target.add(normalized);
      }
    });
  }

  private extractSelectionValues(items: any[]): string[] {
    const values: string[] = [];
    (items || []).forEach((item: any) => {
      if (!item || typeof item !== 'object') {
        return;
      }

      values.push(
        item.Level2,
        item.Level1,
        item.Level0,
        item.response_label,
        item.variable_label,
        item.metric_group,
        item.option,
        item.value,
        item.Name,
        item.Child,
      );
    });
    return values.filter((x) => x != null && x !== '');
  }

  private resolveBucketFromName(name: string): 'ep1' | 'ep2' | 'ep3' | 'd1' | 'd2' | 'd3' | 'time' | 'generic' {
    const key = this.normalizeFilterValue(name);
    if (/entry\s*point\s*1|entrypoint1|e1/.test(key)) return 'ep1';
    if (/entry\s*point\s*2|entrypoint2|e2/.test(key)) return 'ep2';
    if (/entry\s*point\s*3|entrypoint3|e3/.test(key)) return 'ep3';
    if (/entry\s*point|entrypoint/.test(key)) return 'ep1';
    if (/dimension\s*1|dimension1|d1/.test(key)) return 'd1';
    if (/dimension\s*2|dimension2|d2/.test(key)) return 'd2';
    if (/dimension\s*3|dimension3|d3/.test(key)) return 'd3';
    if (/dimension/.test(key)) return 'd1';
    if (/time\s*period|week|month|quarter|year|mma/.test(key)) return 'time';
    return 'generic';
  }

  private getConfiguredSelectionBuckets(): {
    ep1: Set<string>;
    ep2: Set<string>;
    ep3: Set<string>;
    d1: Set<string>;
    d2: Set<string>;
    d3: Set<string>;
    time: Set<string>;
    generic: Set<string>;
  } {
    const buckets = {
      ep1: new Set<string>(),
      ep2: new Set<string>(),
      ep3: new Set<string>(),
      d1: new Set<string>(),
      d2: new Set<string>(),
      d3: new Set<string>(),
      time: new Set<string>(),
      generic: new Set<string>(),
    };

    // Entry-point selections: source from configService.entrypointData
    const entryPointData = this._configService?.entryPointData || this._configService?.entryPointData || [];
    (entryPointData || []).forEach((entry: any) => {
      if (!entry || typeof entry !== 'object') {
        return;
      }

      const ep1Obj = entry?.EntryPoint1;
      const ep2Obj = entry?.EntryPoint2;
      const ep3Obj = entry?.EntryPoint3;

      const readEntryPointValues = (epObj: any): string[] => {
        const values: any[] = [];
        if (!epObj || typeof epObj !== 'object') {
          return [];
        }

        values.push(epObj?.Level1, epObj?.Parent, epObj?.variableCode);

        (epObj?.Level2 || []).forEach((lvl2: any) => {
          values.push(lvl2?.Parent);
          (lvl2?.MetricOptions || []).forEach((opt: any) => {
            values.push(opt?.Name, opt?.responseCode, opt?.value, opt?.Child);
          });
        });

        return values.filter((x) => x != null && x !== '');
      };

      this.addValuesToSet(buckets.ep1, readEntryPointValues(ep1Obj));
      this.addValuesToSet(buckets.ep2, readEntryPointValues(ep2Obj));
      this.addValuesToSet(buckets.ep3, readEntryPointValues(ep3Obj));

      // Dimension selections from entrypointdata.dimension (only selected dimensions)
      (entry?.dimension || []).forEach((dim: any, index: number) => {
        if (!dim?.is_selected) {
          return;
        }

        // Do not use dimension labels/codes (e.g. "Dimension 1", "ageSPSS") as filter values,
        // because uploaded rows contain concrete member values in Dimension1/2/3 columns.
        const dimValues = [
          dim?.value,
          dim?.Name,
          dim?.Child,
          dim?.response_label,
          dim?.option,
        ];

        if (index === 1) {
          this.addValuesToSet(buckets.d1, dimValues);
        } else if (index === 2) {
          this.addValuesToSet(buckets.d2, dimValues);
        } else if (index === 3) {
          this.addValuesToSet(buckets.d3, dimValues);
        } else {
          this.addValuesToSet(buckets.generic, dimValues);
        }
      });
    });

    // Time period selections: source from dataObjectForSaveSelection (= previewData assigned in leftpanel SubmitClicked)
    const savedPreviewData = this._configService?.dataObjectForSaveSelection || this._configService?.savedPreviewData || {};
    const colNesting = savedPreviewData?.colNesting || savedPreviewData?.ColNesting || [];

    (colNesting || []).forEach((entry: any) => {
      const parent = entry?.Parent || entry?.parent || '';
      const childValues = (entry?.Data || entry?.data || []).map((d: any) => d?.Child || d?.child || d?.Name || d?.name);
      this.addValuesToSet(buckets.time, [parent, ...childValues]);
    });

    return buckets;
  }

  private hasAnyConfiguredFilters(buckets: {
    ep1: Set<string>;
    ep2: Set<string>;
    ep3: Set<string>;
    d1: Set<string>;
    d2: Set<string>;
    d3: Set<string>;
    time: Set<string>;
    generic: Set<string>;
  }): boolean {
    return (
      buckets.ep1.size > 0 ||
      buckets.ep2.size > 0 ||
      buckets.ep3.size > 0 ||
      buckets.d1.size > 0 ||
      buckets.d2.size > 0 ||
      buckets.d3.size > 0 ||
      buckets.time.size > 0
    );
  }

  private rowHasMatchForSet(row: any, columns: string[], expectedSet: Set<string>, mandatory: boolean = false): boolean {
    const getRowValueByColumn = (sourceRow: any, column: string): any => {
      if (!sourceRow || typeof sourceRow !== 'object') {
        return undefined;
      }

      if (Object.prototype.hasOwnProperty.call(sourceRow, column)) {
        return sourceRow[column];
      }

      const normalizedColumn = this.normalizeFilterValue(column).replace(/\s+/g, '');
      const matchingKey = Object.keys(sourceRow).find((rowKey: string) =>
        this.normalizeFilterValue(rowKey).replace(/\s+/g, '') === normalizedColumn
      );

      return matchingKey ? sourceRow[matchingKey] : undefined;
    };

    // Collect whatever non-empty values the row actually has for these columns.
    const rowValues = columns
      .map((column) => this.normalizeFilterValue(getRowValueByColumn(row, column)))
      .filter((value) => !!value);

    // Row has no value for this field at all -> nothing to compare, ignore this criterion.
    if (rowValues.length === 0) {
      return true;
    }

    // Row has a value, but no filter is configured for this field.
    if (!expectedSet || expectedSet.size === 0) {
      return !mandatory;
    }

    // Row has a value AND a filter is configured -> it must match.
    return rowValues.some((value) => expectedSet.has(value));
  }

  private getStrictTimeValues(timeSet: Set<string>): Set<string> {
    const strictValues = new Set<string>();
    const skipTokens = new Set([
      'time', 'timeperiod', 'time period', 'month', 'week', 'quarter', 'year',
      '3mma', '4mma', '6mma', '12mma'
    ]);

    (Array.from(timeSet || [])).forEach((rawValue: string) => {
      const normalized = this.normalizeFilterValue(rawValue);
      if (!normalized) {
        return;
      }

      const parts = normalized.split('|').map((part) => this.normalizeFilterValue(part));
      parts.forEach((part) => {
        if (!part || skipTokens.has(part)) {
          return;
        }

        // Keep concrete period tokens such as sep_2025, q1_2025, wk_12, etc.
        if (/\d/.test(part)) {
          strictValues.add(part);

          // Also match compact variants (e.g., "q 1_2026" <-> "q1_2026").
          // const compactPart = part.replace(/\s+/g, '');
          // if (compactPart) {
          //   strictValues.add(compactPart);
          // }
        }
      });
    });

    return strictValues;
  }

  private rowMatchesConfiguredFilters(row: any, buckets: {
    ep1: Set<string>;
    ep2: Set<string>;
    ep3: Set<string>;
    d1: Set<string>;
    d2: Set<string>;
    d3: Set<string>;
    time: Set<string>;
    generic: Set<string>;
  }): boolean {
    const strictTimeValues = this.getStrictTimeValues(buckets.time);
    const timeExpectedSet = strictTimeValues.size > 0 ? strictTimeValues : buckets.time;

    const ep1Ok = this.rowHasMatchForSet(
      row,
      ['Entry points1', 'EntryPoint1', 'Entry points 1', 'Entry Point 1', 'Entry point 1', 'Entry points', 'Entry Point', 'EntryPoint'],
      buckets.ep1
    );
    const ep2Ok = this.rowHasMatchForSet(row, ['Entry points2', 'EntryPoint2', 'Entry points 2', 'Entry Point 2', 'Entry point 2'], buckets.ep2);
    const ep3Ok = this.rowHasMatchForSet(row, ['Entry points3', 'EntryPoint3', 'Entry points 3', 'Entry Point 3', 'Entry point 3'], buckets.ep3);
    const d1Ok = this.rowHasMatchForSet(row, ['Dimension1', 'Dimension 1', 'Dimension', 'Dim1', 'Dim 1'], buckets.d1);
    const d2Ok = this.rowHasMatchForSet(row, ['Dimension2', 'Dimension 2', 'Dim2', 'Dim 2'], buckets.d2);
    const d3Ok = this.rowHasMatchForSet(row, ['Dimension3', 'Dimension 3', 'Dim3', 'Dim 3'], buckets.d3);
    const timeOk = this.rowHasMatchForSet(
      row,
      ['Week', 'Month', 'Quarter', 'Year', '3MMA', '4MMA', '6MMA', '12MMA', 'Time Period', 'TimePeriod'],
      timeExpectedSet,
      true
    );

    return ep1Ok && ep2Ok && ep3Ok && d1Ok && d2Ok && d3Ok && timeOk;
  }

  private filterUploadedRowsByConfiguredSelections(uploadedMetricRows: any[]): any[] {
    if (!Array.isArray(uploadedMetricRows) || uploadedMetricRows.length === 0) {
      return [];
    }

    const buckets = this.getConfiguredSelectionBuckets();
    if (!this.hasAnyConfiguredFilters(buckets)) {
      return uploadedMetricRows;
    }

    const filteredRows = uploadedMetricRows.filter((row: any) => this.rowMatchesConfiguredFilters(row, buckets));
    return filteredRows;
  }

  private getNumericMetricValue(row: any): number | null {
    const rawValue = row?.value ?? row?.Value ?? row?.['Value'];
    if (rawValue == null || rawValue === '') {
      return null;
    }

    if (typeof rawValue === 'number' && Number.isFinite(rawValue)) {
      return rawValue;
    }

    const cleanedValue = String(rawValue)
      .replace(/,/g, '')
      .replace(/%/g, '')
      .trim();
    const parsedValue = Number(cleanedValue);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  private buildMetricDictionaryFromRows(metricRows: any[]): any {
    const groupedByMetricName: {
      [normalizedMetricName: string]: {
        metricName: string;
        templateRow: any;
        sum: number;
        count: number;
      }
    } = {};

    (metricRows || []).forEach((row: any) => {
      const metricName = row?.metricName ?? row?.MetricName ?? row?.['Metric Name'];
      if (metricName == null || metricName === '') {
        return;
      }

      const metricNameText = String(metricName).trim();
      const normalizedMetricName = this.normalizeFilterValue(metricNameText) || metricNameText.toLowerCase();

      if (!groupedByMetricName[normalizedMetricName]) {
        groupedByMetricName[normalizedMetricName] = {
          metricName: metricNameText,
          templateRow: row,
          sum: 0,
          count: 0,
        };
      }

      const numericValue = this.getNumericMetricValue(row);
      if (numericValue != null) {
        groupedByMetricName[normalizedMetricName].sum += numericValue;
      groupedByMetricName[normalizedMetricName].count += 1;
      }
    });

    return Object.values(groupedByMetricName).reduce((dictionary: any, groupedMetric: any) => {
      const averageValue = groupedMetric.count > 0
        ? groupedMetric.sum / groupedMetric.count
        : (groupedMetric.templateRow?.value ?? groupedMetric.templateRow?.Value ?? groupedMetric.templateRow?.['Value']);

      const aggregatedRow = {
        ...groupedMetric.templateRow,
        metricName: groupedMetric.metricName,
        MetricName: groupedMetric.metricName,
        value: averageValue,
        Value: averageValue,
      };

      // Keep full row shape so existing lookup and export paths continue to work.
      dictionary[groupedMetric.metricName] = aggregatedRow;
      return dictionary;
    }, {});
  }

  private getDictionaryValueForCategory(uploadedMetricDictionary: any, category: any): any {
    const normalizeMetricLookupValue = (value: any): string => {
      const normalized = this.normalizeFilterValue(value);
      if (!normalized) {
        return '';
      }

      // Remove leading/trailing punctuation/quotes and normalize separators/spaces.
      return normalized
        .replace(/^[^a-z0-9]+|[^a-z0-9]+$/gi, '')
        .replace(/[|:_-]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    };

    const getMetricTail = (value: any): string => {
      const raw = String(value ?? '');
      if (!raw) {
        return '';
      }
      const parts = raw.split('|').map((x) => normalizeMetricLookupValue(x));
      return parts[parts.length - 1] || value;
    };

    const toCoreMetricPhrase = (value: any): string => {
      const normalized = normalizeMetricLookupValue(value);
      if (!normalized) {
        return '';
      }

      return normalized
        .replace(/^(attributes?|benefits?|reasons?|statements?)\s+/i, '')
        .replace(/\b(strongly agree|agree|neutral|disagree|strongly disagree|very likely|likely|unlikely|very unlikely)\b$/i, '')
        .replace(/\s+/g, ' ')
        .trim();
    };

    const categoryKey = normalizeMetricLookupValue(category);
    if (!categoryKey || !uploadedMetricDictionary) {
      return undefined;
    }

    const matchingEntry = Object.entries(uploadedMetricDictionary).find(([key, value]: [string, any]) => {
      const metricNameRaw = value?.metricName ?? value?.MetricName ?? value?.['Metric Name'];
      const normalizedKey = normalizeMetricLookupValue(key);
      const metricNameFromRow = normalizeMetricLookupValue(metricNameRaw);

      const candidates = [normalizedKey, metricNameFromRow].filter((x) => !!x);
      const rawCandidates = [key, metricNameRaw].filter((x) => !!x);
      const categoryCore = toCoreMetricPhrase(categoryKey);

      return candidates.some((candidate) => {
        const matchingRawCandidate = rawCandidates.find((raw) => normalizeMetricLookupValue(raw) === candidate) || candidate;
        const candidateTail = getMetricTail(matchingRawCandidate);
        const candidateCore = toCoreMetricPhrase(candidate) || toCoreMetricPhrase(candidateTail);

        if (candidate === categoryKey || candidateTail === categoryKey || candidateCore === categoryCore) {
          return true;
        }

        // Handle cases where category is only a suffix or includes small leading punctuation differences.
        return (
          candidate.endsWith(categoryKey) ||
          categoryKey.endsWith(candidate) ||
          candidateTail.endsWith(categoryKey) ||
          categoryKey.endsWith(candidateTail) ||
          (!!candidateCore && !!categoryCore && (candidateCore.includes(categoryCore) || categoryCore.includes(candidateCore)))
        );
      });
    });

    if (matchingEntry) {
      const entry: any = matchingEntry[1];
      // If the stored entry is a full row object, extract the numeric value.
      if (entry !== null && typeof entry === 'object') {
        return entry?.value ?? entry?.Value ?? entry?.['Value'];
      }
      return entry;
    }

    return undefined;
  }

  private getFilteredMetricDictionary(additionalColumn: any): any {
    const fallbackDictionary = additionalColumn?.uploadedMetricDictionary || {};

    const uploadedMetricRows: any[] = Array.isArray(additionalColumn?.uploadedMetricRows)
      ? additionalColumn.uploadedMetricRows
      : [];

    const extractRowsFromDictionary = (source: any): any[] => {
      if (!source) {
        return [];
      }

      // Full-response shapes: array directly or { data: [...] }
      if (Array.isArray(source)) {
        return source;
      }
      if (Array.isArray(source?.data)) {
        return source.data;
      }

      // Legacy shape: { metricName: rowObject, ... }
      const values = Object.values(source);
      if (
        values.length > 0 &&
        values.every((v: any) => v !== null && typeof v === 'object' && !Array.isArray(v))
      ) {
        return values as any[];
      }

      return [];
    };

    // Prefer explicit uploadedMetricRows if present. This avoids misreading response-wrapper objects.
    const rowsSource: any[] = uploadedMetricRows.length > 0
      ? uploadedMetricRows
      : extractRowsFromDictionary(fallbackDictionary);

    // No rows available at all — return the dictionary as-is (legacy scalar-value path).
    if (rowsSource.length === 0) {
      return fallbackDictionary;
    }

    const buckets = this.getConfiguredSelectionBuckets();
    const hasConfiguredFilters = this.hasAnyConfiguredFilters(buckets);

    const filteredRows = this.filterUploadedRowsByConfiguredSelections(rowsSource);
    const filteredDictionary = this.buildMetricDictionaryFromRows(filteredRows);

    if (filteredDictionary && Object.keys(filteredDictionary).length > 0) {
      return filteredDictionary;
    }

    // In filtered mode (EP x Dimension x TP), do NOT fallback to unfiltered dictionary.
    // Returning empty dictionary ensures non-matching metrics render as NA.
    if (hasConfiguredFilters) {
      return {};
    }

    return fallbackDictionary;
  }

  private processAdditionalColumn(): void {
    // Check if additionalColumn property exists and is not null/undefined
    if (!this.properties?.additionalColumn) {
      this.additionalColumnInfos = [];
      // Clear any previously stored filtered export data for this widget
      this._configService.filteredAdditionalColumnExportData =
        (this._configService.filteredAdditionalColumnExportData || []).filter(
          (e: any) => e.widget_name !== this.CurrentWidgetName,
        );
      return;
    }

    try {
      // Parse additionalColumn if it's a string
      const additionalColumnRaw = typeof this.properties.additionalColumn === 'string'
        ? JSON.parse(this.properties.additionalColumn)
        : this.properties.additionalColumn;

      const configuredColumns = Array.isArray(additionalColumnRaw) ? additionalColumnRaw : [additionalColumnRaw];
      this.additionalColumnInfos = [];

      // Collect export-ready entries using already-filtered metric data (filtered by
      // entry points, time periods, and brands via getFilteredMetricDictionary)
      const filteredExportEntries: any[] = [];

      configuredColumns.forEach((configuredColumn: any) => {
        const additionalColumn = configuredColumn?.additionalColumnDetails || configuredColumn;

        // Null checks for critical properties
        if (!additionalColumn?.additionalColumnForm) {
          return;
        }

        const columnForm = additionalColumn.additionalColumnForm;
        if (!columnForm?.columnHeader || !columnForm?.columnPosition) {
          return;
        }

        // Keep semantic positions as configured:
        // 1 -> before Metric column, 2 -> after Metric column.
        const parsedColumnPosition = parseInt(columnForm.columnPosition, 10);
        if (isNaN(parsedColumnPosition) || (parsedColumnPosition !== 1 && parsedColumnPosition !== 2)) {
          return;
        }
        const columnPos = parsedColumnPosition;

        // Filter uploaded rows by configured selections and build effective dictionary.
        const uploadedMetricDictionary = this.getFilteredMetricDictionary(additionalColumn);
        const positiveValue = parseFloat(columnForm.positiveValue) || 0;
        const negativeValue = parseFloat(columnForm.negativeValue) || 0;

        // Build export metrics from the already-filtered dictionary
        const metricValueRows: any[] = [];
        Object.keys(uploadedMetricDictionary || {}).forEach((key: string) => {
          const entry = uploadedMetricDictionary[key];
          if (entry !== null && typeof entry === 'object' && !Array.isArray(entry)) {
            const metricName = entry?.metricName ?? entry?.MetricName ?? entry?.['Metric Name'] ?? key;
            const value = entry?.value ?? entry?.Value ?? entry?.['Value'];
            if (metricName != null && metricName !== '') {
              metricValueRows.push({ metricName, value });
            }
          } else if (entry != null) {
            metricValueRows.push({ metricName: key, value: entry });
          }
        });

        if (metricValueRows.length > 0) {
          filteredExportEntries.push({
            widget_name: this.CurrentWidgetName,
            columnHeader: columnForm.columnHeader || '',
            columnPosition: columnForm.columnPosition || '',
            sortingOrder: columnForm.sortingOrder || '',
            positiveValue: columnForm.positiveValue ?? '',
            negativeValue: columnForm.negativeValue ?? '',
            metrics: metricValueRows,
          });
        }

        // Add the additional column data to chartMainData
        this.addAdditionalColumnToData(columnForm, columnPos, uploadedMetricDictionary, positiveValue, negativeValue);
      });

      // Replace any previous filtered export data for this widget with the freshly filtered entries
      this._configService.filteredAdditionalColumnExportData = [
        ...(this._configService.filteredAdditionalColumnExportData || []).filter(
          (e: any) => e.widget_name !== this.CurrentWidgetName,
        ),
        ...filteredExportEntries,
      ];

      this.properties.additionalColumnInfos = [...this.additionalColumnInfos];
      // Keep legacy field for backward compatibility where a single object is expected.
      this.properties.additionalColumnInfo = this.additionalColumnInfos[0] || null;
    } catch (error) {
      console.error('Error processing additional column:', error);
    }
  }

  private addAdditionalColumnToData(columnForm: any, columnPos: number, uploadedMetricDictionary: any = {}, positiveValue: number = 0, negativeValue: number = 0): void {
    if (!this.chartMainData || this.chartMainData.length === 0) {
      return;
    }

    // Extract unique category names from existing data
    let categoryFieldName = 'Category Name';
    if (this.properties?.Transpose1) {
      categoryFieldName = 'Series Name';
    }

    const uniqueCategories = [...new Set(
      this.chartMainData.map((row: any) => row[categoryFieldName])
    )];

    // Create new rows for the additional column as a new series
    const newSeriesRows: any[] = [];
    uniqueCategories.forEach((category: any) => {
      // Look up value from uploadedMetricDictionary. If unavailable, render as NA.
      const dictionaryValue = this.getDictionaryValueForCategory(uploadedMetricDictionary, category) ?? 'NA';

      const numericValue = typeof dictionaryValue === 'string' ? parseFloat(dictionaryValue) : dictionaryValue;
      const finalValue = (dictionaryValue === 'NA' || isNaN(numericValue)) ? 'NA' : numericValue;

      // Determine color based on thresholds
      let cellColor = 'black';
      if (typeof finalValue === 'number' && finalValue >= positiveValue) {
        cellColor = 'green';
      } else if (typeof finalValue === 'number' && finalValue <= negativeValue) {
        cellColor = 'red';
      }

      const newRow = {
        'Series Name': columnForm.columnHeader,
        'Category Name': category,
        'Rounded Value': finalValue,
        'Value': finalValue,
        'ValueForIndex': finalValue,
        'ActualIndexValue': finalValue,
        'Label': finalValue,
        'Change value vs PY': 0,
        'Significance': '0',
        'Sample size': 0,
        'Significance2': '0',
        'isPercentage': false,
        'Sig_LowerLimt': this.Sig_LowerLimt,
        'Sig_UpperLimt': this.Sig_UpperLimt,
        'Significance_Value': 0,
        'isMultiPunch': 0,
        'additionalColumnColor': cellColor
      };

      // Handle transpose case
      if (this.properties?.Transpose1) {
        newRow['Series Name'] = category;
        newRow['Category Name'] = columnForm.columnHeader;
      }

      newSeriesRows.push(newRow);
    });

    // Add new series rows to chartMainData
    this.chartMainData.push(...newSeriesRows);

    // Track placement/info for each configured additional column.
    const columnInfo = {
      columnHeader: columnForm.columnHeader,
      columnPos: columnPos,
      hoverOverText: columnForm.hoverOverText || '',
      positiveValue: columnForm.positiveValue || '',
      negativeValue: columnForm.negativeValue || '',
      sortingOrder: this.normalizeAdditionalColumnSortOrder(columnForm.sortingOrder)
    };

    const existingIndex = this.additionalColumnInfos.findIndex((x) => x.columnHeader === columnInfo.columnHeader);
    if (existingIndex >= 0) {
      this.additionalColumnInfos[existingIndex] = columnInfo;
    } else {
      this.additionalColumnInfos.push(columnInfo);
    }

    // Sort categories by additional column value (ascending by default)
    this.sortCategoriesByAdditionalColumn(columnForm.columnHeader, this.normalizeAdditionalColumnSortOrder(columnForm.sortingOrder));
  }

  private sortCategoriesByAdditionalColumn(columnHeader: string, sortOrder: 'ascending' | 'descending' = 'ascending'): void {
    if (!columnHeader || !this.categories || this.categories.length === 0) {
      return;
    }

    // Build a map of category -> additional column value
    const categoryValueMap: { [key: string]: number | string } = {};
    this.categories.forEach((category: string) => {
      const rowInData = this.chartMainData.find((row: any) => {
        if (this.properties?.Transpose1) {
          return row['Series Name'] === columnHeader && row['Category Name'] === category;
        } else {
          return row['Series Name'] === columnHeader && row['Category Name'] === category;
        }
      });

      if (rowInData) {
        const value = rowInData['Rounded Value'];
        categoryValueMap[category] = value === 'NA' ? (sortOrder === 'ascending' ? Infinity : -Infinity) : Number(value);
      } else {
        categoryValueMap[category] = sortOrder === 'ascending' ? Infinity : -Infinity;
      }
    });

    // Sort categories based on values
    this.categories.sort((a: string, b: string) => {
      const valueA = categoryValueMap[a] as number;
      const valueB = categoryValueMap[b] as number;

      if (sortOrder === 'ascending') {
        return valueA - valueB;
      } else {
        return valueB - valueA;
      }
    });

    // Update categories2 with sorted order
    this.categories2 = this.categories.map((category: string) => {
      return { colname: category, sortorder: 'nosort' };
    });
  }
  private isAdditionalColumnValueNA(value: any): boolean {
    if (value == null) {
      return true;
    }

    const text = String(value).trim().toLowerCase();
    return text === '' || text === 'na';
  }

  private isConfiguredAdditionalColumnHeader(header: string): boolean {
    return this.additionalColumnInfos.some((info) => info.columnHeader === header);
  }

  private getVisibleAdditionalColumnInfos(): Array<{ columnHeader: string; columnPos: number; hoverOverText: string; positiveValue?: string; negativeValue?: string; sortingOrder?: 'ascending' | 'descending' }> {
    return this.additionalColumnInfos.filter((info) =>
      this.renderableAdditionalColumnHeaders.has(info.columnHeader)
    );
  }

  private hasAtLeastOneDataInAdditionalColumn(columnHeader: string, chartData: any[]): boolean {
    const relatedRows = (chartData || []).filter((row: any) => {
      if (this.properties?.Transpose1) {
        return row['Category Name'] === columnHeader;
      }
      return row['Series Name'] === columnHeader;
    });

    if (!relatedRows.length) {
      return false;
    }

    return relatedRows.some((row: any) => {
      const rawValue = row?.['Label'] ?? row?.['Rounded Value'] ?? row?.['Value'];
      return !this.isAdditionalColumnValueNA(rawValue);
    });
  }

  private hasNAInRenderableAdditionalColumns(category: string, chartData: any[]): boolean {
    if (!this.renderableAdditionalColumnHeaders || this.renderableAdditionalColumnHeaders.size === 0) {
      return false;
    }

    for (const columnHeader of this.renderableAdditionalColumnHeaders) {
      const matchingItem = (chartData || []).find((row: any) => {
        if (this.properties?.Transpose1) {
          return row['Series Name'] === category && row['Category Name'] === columnHeader;
        }
        return row['Category Name'] === category && row['Series Name'] === columnHeader;
      });

      const rawValue = matchingItem?.['Label'] ?? matchingItem?.['Rounded Value'] ?? matchingItem?.['Value'];
      if (this.isAdditionalColumnValueNA(rawValue)) {
        return true;
      }
    }

    return false;
  }

  isAdditionalColumnHeader(header: string): boolean {
    return this.renderableAdditionalColumnHeaders.has(header);
  }

  getAdditionalColumnHoverText(header: string): string {
    const info = this.getVisibleAdditionalColumnInfos().find((x) => x.columnHeader === header);
    return info?.hoverOverText || '';
  }

  getAdditionalColumnInfo(header: string): { columnHeader: string; columnPos: number; hoverOverText: string; positiveValue?: string; negativeValue?: string } | null {
    return this.getVisibleAdditionalColumnInfos().find((x) => x.columnHeader === header) || null;
  }

  private getDefaultAdditionalColumnSortConfig(): { columnHeader: string; sortOrder: 'ascending' | 'descending' } | null {
    const visibleInfos = this.getVisibleAdditionalColumnInfos();
    if (!visibleInfos || visibleInfos.length === 0) {
      return null;
    }

    const preMetricInfo = visibleInfos.find((x) => Number(x.columnPos) === 1);
    const info = preMetricInfo || visibleInfos[0];
    if (!info?.columnHeader) {
      return null;
    }

    return {
      columnHeader: info.columnHeader,
      sortOrder: this.normalizeAdditionalColumnSortOrder(info.sortingOrder)
    };
  }

  toggleAdditionalColumnInfo(header: string, event: MouseEvent): void {
    event.stopPropagation();

    if (this.activeAdditionalColumnHeader === header) {
      this.activeAdditionalColumnHeader = null;
      this.additionalColumnPopupPosition = null;
      return;
    }

    const target = event.currentTarget as HTMLElement | null;
    const rect = target?.getBoundingClientRect();
    const headerRect = target?.closest('th')?.getBoundingClientRect();
    if (rect || headerRect) {
      const anchorRect = headerRect || rect;
      this.additionalColumnPopupPosition = {
        top: Math.max(8, (anchorRect?.top || 0) + 4),
        right: Math.max(8, window.innerWidth - (anchorRect?.right || 0) + 12)
      };
    }

    this.activeAdditionalColumnHeader = header;
  }

  isAdditionalColumnInfoOpen(header: string): boolean {
    return this.activeAdditionalColumnHeader === header;
  }

  @HostListener('document:click')
  closeAdditionalColumnInfo(): void {
    this.activeAdditionalColumnHeader = null;
    this.additionalColumnPopupPosition = null;
  }
 getPreMetricAdditionalHeader(): string {
    const visibleInfos = this.getVisibleAdditionalColumnInfos();
    if (!visibleInfos || visibleInfos.length === 0) {
      return '';
    }

    const info = visibleInfos.find((x) => Number(x.columnPos) === 1);

    return info?.columnHeader || '';
  }

  getRenderableHeaders(): string[] {
    const preMetricHeader = this.getPreMetricAdditionalHeader();
    const renderableHeaders = preMetricHeader
      ? (this.headers || []).filter((h: string) => h !== preMetricHeader)
      : (this.headers || []);

    const postMetricHeaders = this.getVisibleAdditionalColumnInfos()
      .filter((info) => Number(info.columnPos) === 2)
      .map((info) => info.columnHeader)
      .filter((header, index, headers) => headers.indexOf(header) === index);

    if (postMetricHeaders.length === 0) {
      return renderableHeaders;
    }

    const orderedHeaders = renderableHeaders.filter((header: string) => !postMetricHeaders.includes(header));
    const insertAt = 0;
    orderedHeaders.splice(insertAt, 0, ...postMetricHeaders);

    return orderedHeaders;
  }

  private reorderHeadersForAdditionalColumn(): void {
    const visibleInfos = this.getVisibleAdditionalColumnInfos();
    if (!visibleInfos || visibleInfos.length === 0) {
      return;
    }

    visibleInfos.forEach((info) => {
      const columnHeader = info.columnHeader;
      let columnPos = parseInt(String(info.columnPos), 10);

      if (isNaN(columnPos)) {
        return;
      }

      // Position mapping requirement:
      // 1 -> before Metric (handled by dedicated pre-metric render in template)
      // 2 -> immediately after Metric (first data header -> index 0 in headers array)
      const targetHeaderIndex = columnPos === 2 ? 0 : 0;

      const headerIndex = this.headers?.indexOf(columnHeader);
      if (headerIndex === undefined || headerIndex === -1 || !this.headers) {
        return;
      }

      this.headers.splice(headerIndex, 1);
      const safeTargetIndex = Math.max(0, Math.min(targetHeaderIndex, this.headers.length));
      this.headers.splice(safeTargetIndex, 0, columnHeader);
    });

    this.headers2 = this.headers.map((category: string) => {
      return { colname: category, sortorder: 'nosort' };
    });
  }

  preparemainChartData(data: any) {
    this.chartMainData = [];
    // Reset stored originals when fresh data is loaded
    this.originalChartMainData = null;
    this.originalCategories = null;
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;

    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": dataArr.colChild.split("|").length > 1 ? dataArr.colChild.split("|")[1] : dataArr.colChild,
            "Category Name": lev2.option,
            "Rounded Value": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? (this.properties.CalculationLogic != "BIPS" ? dataArr.data * 100 : dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "Value": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? (this.properties.CalculationLogic != "BIPS" ? dataArr.data * 100 : dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && (dataArr.data2 == "NA" || dataArr.data2 == null || dataArr.data2 == undefined) ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? "NA" : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? (this.properties.CalculationLogic != "BIPS" ? dataArr.data * 100 : dataArr.data) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" || dataArr.CalculationType?.toLowerCase() == "meanpercentage" ? this.properties.CalculationLogic != "BIPS" ? true : false : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "isMultiPunch": dataArr.isMultiPunch
          }
          this.chartMainData.push(d1);
        })
      })
    }
    else {
      let i = 0;
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": this.getSeriesName(dataArr),
            "Category Name": lev2.option,
            "Rounded Value": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "Value": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" && dataArr.data2 == null && dataArr.data2 == undefined ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? "NA" : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data != null ? (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)) : "NA",
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "isMultiPunch": dataArr.isMultiPunch
          }
          this.chartMainData.push(d1);
        });
      });
    }

   
    if (this.properties?.additionalColumn) {
      const dedupeMap = new Map<string, { template: any; sum: number; count: number }>();
      this.chartMainData.forEach((item: any) => {
        const key = `${item['Category Name']}|||${item['Series Name']}`;
        if (!dedupeMap.has(key)) {
          dedupeMap.set(key, { template: item, sum: 0, count: 0 });
        }
        const entry = dedupeMap.get(key)!;
        const raw = item['Value'];
        const num = (raw == null || raw === '' || raw === 'NA') ? NaN : Number(raw);
        if (!isNaN(num)) {
          entry.sum += num;
          entry.count += 1;
        }
      });

      this.chartMainData = Array.from(dedupeMap.values()).map(({ template, sum, count }) => {
        if (count === 0) {
          // All values were null/NA — keep original row as-is
          return template;
        }
        const avg = sum / count;
        return {
          ...template,
          'Value': avg,
          'Rounded Value': avg,
          'Label': avg,
        };
      });
    }

    this.maxData = Math.max(
      ...this.chartMainData
        .map((item: any) => Number(item["Value"])) // Convert "Value" to a number
        .filter((value: any) => !isNaN(value)) // Filter out invalid values like "NA"
    );
    this.minData = Math.min(
      ...this.chartMainData
        .map((item: any) => Number(item["Value"])) // Convert "Value" to a number
        .filter((value: any) => !isNaN(value)) // Filter out invalid values like "NA"
    );

  }

  getSeriesName(dataArr: any): string {
    const p = dataArr.colChild?.split('|');
    const isAudienceSnapshot = this._configService.selectedSnapshotType?.toLowerCase().includes('audience');
    
    if (isAudienceSnapshot && p?.length === 3 && p[0]?.toLowerCase() === 'audience') {
      return p[2];
    } else {
      return dataArr.colChild.split("|").length > 1
        ? dataArr.colChild.split("|")[1]
        : dataArr.colChild; 
    }
  }

  getBarWidth(value: any): string {
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    }
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }
    const maxValue = Math.abs(this.maxData) > Math.abs(this.minData) ? Math.abs(this.maxData) : Math.abs(this.minData); // Set max value for scaling (adjust as needed)
    let percentage = (Math.abs(value) / maxValue) * (this.properties.CalculationLogic == 'None' ? 20 : 30); // Scale to 50%
    return `${percentage}%`;
  }

  getActualNumber(value: any) {
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }
    return value;
  }

  getBarClass(value: any): string {
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }
    return value >= 0 ? 'positive' : 'negative';
  }
  getMarginLeft(value: any): string {
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }
    return value < 0 ? '0' : 'auto'; // Push positive bars to the right
  }

  isValueLessThanZero(value: any) {
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    }
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }

    return value < 0;
  }

  isValueGreaterThanZero(value: any) {
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    }
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }

    return value > 0;
  }

  isValueEqualToZero(value: any) {
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    }
    if (!isNaN(value.changingThisBreaksApplicationSecurity)) {
      value = Number(value.changingThisBreaksApplicationSecurity);
    }
    else {
      value = 0;
    }

    return value == 0;
  }


  onTableDataChange(event: any) {
    this.p = event;
    this.start = (this.p - 1) * this.itemsPerPage;
    this.end = this.start + this.itemsPerPage;

    this.getData(this.tableData, this.start, this.end, " ", this.sorting);
  }
  //search($event) function to search the table data based on the input value
  search(event: any) {
    const input = event.target.value.toUpperCase();
    const table = this.customTable?.nativeElement;
    const rows = table?.querySelectorAll('.table-rows');

    if (rows) {
      rows.forEach((row: { querySelectorAll: (arg0: string) => any; style: { display: string; }; }) => {
        const cells = row.querySelectorAll('.data-cells');

        let rowMatch = false;

        cells.forEach((cell: { textContent: any; innerText: any; }) => {
          const textContent = cell.textContent || cell.innerText;
          if (textContent.toUpperCase().indexOf(input) > -1) {
            rowMatch = true;
          }
        });


        row.style.display = rowMatch ? '' : 'none';
      });
    }
    const rows2 = table?.querySelectorAll('.table-rows3');

    const headerCells = table?.querySelectorAll('.header-cells');
    if (headerCells) {
      headerCells.forEach((header: { textContent: any; innerText: any; }, index: number) => {
        const textContent = header.textContent || header.innerText;
        const columnCells = table.querySelectorAll(`.data-cells:nth-child(${index + 1})`);

        if (textContent.toUpperCase().indexOf(input) > -1) {
          columnCells.forEach((cell: { parentElement: { style: { display: string; }; }; }) => {
            if (cell.parentElement) {
              cell.parentElement.style.display = ''; // Show the entire column
            }

          });
        }
      });
    }
  }
  shouldShowRow(row: any) {
    // Get the category name from the row
    if (this.properties.suppressRow) {
      if (!this.properties.transpose) {
        const categoryName = row;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Category Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );

        // Remove the categoryName from this.categories if all values are empty
        if (allValuesEmpty) {
          this.categories = this.categories.filter(category => category !== categoryName);
          this.categories2 = this.categories.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });
        }

        return allValuesEmpty;
      }
      if (this.properties.transpose) {
        const categoryName = row;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Series Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );

        // Remove the categoryName from this.categories if all values are empty
        if (allValuesEmpty) {
          this.categories = this.categories.filter(category => category !== categoryName);
          this.categories2 = this.categories.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });

        }

        return allValuesEmpty;
      }
    }
  }
  //getBorderStyle(side: string): string {
  //  let borderStyle = this.properties.borderStyle;
  //  if (this.properties.borderStyle === 'dotted') {
  //    // Increase border thickness by 1 if border style is 'dotted'
  //    borderStyle += ' ' + (parseInt(this.tableService.borderThickness) + 1) + 'px';
  //  } else {
  //    // Otherwise, use the original border thickness
  //    borderStyle += ' ' + this.tableService.borderThickness;
  //  }

  //  // Construct and return the border style for the specified side
  //  return borderStyle + ' ' + this.properties.border;
  //}


  shouldShowCol(col: any) {

    if (this.properties.suppressColumn) {
      if (!this.properties.transpose) {
        const categoryName = col;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Series Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );
        if (allValuesEmpty) {
          this.headers = this.headers.filter((header: any) => header !== categoryName);
          this.headers2 = this.headers.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });
        }
        return allValuesEmpty;
      }
      if (this.properties.transpose) {
        const categoryName = col;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Category Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );
        if (allValuesEmpty) {
          this.headers = this.headers.filter((header: any) => header !== categoryName);
          this.headers2 = this.headers.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });
        }
        return allValuesEmpty;
      }
    }


  }
  sortAscending(header: any, sortorder: any) {
    this.sorting = sortorder;
    this.sortDirectionAsc = !this.sortDirectionAsc;
    this.header2 = [];
    this.header2.push(header);
    this.header2.push(sortorder);
    // Implement sorting logic for ascending order based on the clicked header
    this.headers2 = this.headers.map((category: string) => {
      return {
        colname: category,
        sortorder: category === header ? sortorder : 'nosort'
      };
    });
    this.getData(this.tableData, this.start, this.end, header, sortorder);
  }

  sortDescending(header: any, sortorder: any) {
    // Implement sorting logic for descending order based on the clicked header
    this.sorting = sortorder;
    this.sortDirectionDesc = !this.sortDirectionDesc;
    this.header2 = [];
    this.header2.push(header);
    this.header2.push(sortorder);
    this.headers2 = this.headers.map((category: string) => {
      return {
        colname: category,
        sortorder: category === header ? sortorder : 'nosort'
      };
    });
    this.getData(this.tableData, this.start, this.end, header, sortorder);
  }


  sortColumn(header: any, sortorder: any) {
    this.clickCounts[header] = this.clickCounts[header] || 0;

    // Increment the click count for the header
    this.clickCounts[header]++;

    // Now you have access to sortOrder (asc or desc) in your TypeScript logic
    if (!this.properties.transpose) {
      this.headers2 = this.headers.map((category: string) => {
        return {
          colname: category,
          sortorder: category === header ? this.getNewSortOrder(this.clickCounts[header]) : 'nosort'
        };
      });
    }
    else {
      this.categories2 = this.categories.map((category: string) => {
        return {
          colname: category,
          sortorder: category === header ? this.getNewSortOrder(this.clickCounts[header]) : 'nosort'
        };
      });
    }
    // Call  getData function
    // this.getData(this.tableData, this.start, this.end, header);
  }

  getNewSortOrder(clickCount: number): string {
    // Implement your logic here to determine the new sort order based on the click count
    const totalSortOrders = 2; // Assuming you have 2 sort orders: 'asc' and 'desc'
    return clickCount % totalSortOrders === 1 ? 'asc' : 'desc';

  }
  
   newData = [{
    "Series Name": "Attribute Importance Score",
    "Category Name": "Aided Brand Awareness",
    "Rounded Value": 92.16791179744199,
    "Value": 92.16791179744199,
    "Label": 92.16791179744199,
    "Change value vs PY": null,
    "Significance": "-1",
    "Sample size": 16320,
    "Significance2": "1",
    "isPercentage": true,
    "Sig_LowerLimt": -1.96,
    "Sig_UpperLimt": 1.96,
    "Significance_Value": null,
    "isMultiPunch": 2, 	
    "tooltipText":"Hello, How are you!",
    "IsAttributeRaw" : true
},
{
    "Series Name": "Attribute Importance Score",
    "Category Name": "Aided Advertising Awareness",
    "Rounded Value": 7.115822351898113,
    "Value": 7.115822351898113,
    "Label": 7.115822351898113,
    "Change value vs PY": null,
    "Significance": "-1",
    "Sample size": 16320,
    "Significance2": "1",
    "isPercentage": true,
    "Sig_LowerLimt": -1.96,
    "Sig_UpperLimt": 1.96,
    "Significance_Value": null,
    "isMultiPunch": 2,
    "tooltipText":"Hello, How are you!",
  	"IsAttributeRaw" : true
},
{
    "Series Name": "Attribute Importance Score12",
    "Category Name": "Aided Brand Awareness",
    "Rounded Value": 92.16791179744199,
    "Value": 92.16791179744199,
    "Label": 92.16791179744199,
    "Change value vs PY": null,
    "Significance": "-1",
    "Sample size": 16320,
    "Significance2": "1",
    "isPercentage": true,
    "Sig_LowerLimt": -1.96,
    "Sig_UpperLimt": 1.96,
    "Significance_Value": null,
    "isMultiPunch": 2, 	
    "tooltipText":"Hello, namste!",
    "IsAttributeRaw" : true
},
{
    "Series Name": "Attribute Importance Score12",
    "Category Name": "Aided Advertising Awareness",
    "Rounded Value": 7.115822351898113,
    "Value": 7.115822351898113,
    "Label": 7.115822351898113,
    "Change value vs PY": null,
    "Significance": "-1",
    "Sample size": 16320,
    "Significance2": "1",
    "isPercentage": true,
    "Sig_LowerLimt": -1.96,
    "Sig_UpperLimt": 1.96,
    "Significance_Value": null,
    "tooltipText":"Hello, namste!",
    "isMultiPunch": 2,
  	"IsAttributeRaw" : true
}]

  getData(chartData: any, start: any, end: any, colName: any, sortorder: any, skipSorting: boolean = false, preserveCategories: boolean = false) {
    // Limit the categories to 10 for the table view
    let seriesData: any[] = [];
    let valuesArray: any[][] = [];
    let deletedCategories: { categoryName: any; seriesWithEmptyValue: any[]; itemData: any[]; }[] = [];
    let sort = sortorder

    // Only re-extract categories if not preserving sorted order
    if (!preserveCategories) {
      if (this.properties.Transpose1) {

        this.headers = this.extractUniqueValues(chartData, 'Category Name');
        this.headers2 = this.headers.map((category: string) => {
          return { colname: category, sortorder: category === colName ? sort : 'nosort' };
        });

        this.categories = this.extractUniqueValues(chartData, 'Series Name');
        this.categories2 = this.categories.map((category: string) => {
          return {
            colname: category, sortorder: category === colName ? sort : 'nosort'
          };
        });



      } else {

        this.headers = this.extractUniqueValues(chartData, 'Series Name');
        this.headers2 = this.headers.map((category: string) => {
          return { colname: category, sortorder: category === colName ? sort : 'nosort' };
        });
        this.categories = this.extractUniqueValues(chartData, 'Category Name');
        this.categories2 = this.categories.map((category: string) => {
          return { colname: category, sortorder: category === colName ? sort : 'nosort' };
        });
      }
    } else {
      // When preserving categories, just update the sortorder in categories2
      this.categories2 = this.categories.map((category: string) => {
        return { colname: category, sortorder: category === colName ? sort : 'nosort' };
      });
    }

    if (this.isOutput) {
      //if (this.properties.hideNA) {
        let columnName = 'Series Name';
        let RowName = 'Category Name';
        if (this.properties.Transpose1) {
          columnName = 'Category Name';
          RowName = 'Series Name';
        }
        const configuredAdditionalHeaders = new Set(
          (this.additionalColumnInfos || []).map((info) => info.columnHeader)
        );
        this.renderableAdditionalColumnHeaders = new Set(
          Array.from(configuredAdditionalHeaders).filter((header) =>
            this.hasAtLeastOneDataInAdditionalColumn(header, chartData)
          )
        );

        if (configuredAdditionalHeaders.size > 0) {
          this.headers = (this.headers || []).filter((header: string) =>
            !this.isConfiguredAdditionalColumnHeader(header) ||
            this.renderableAdditionalColumnHeaders.has(header)
          );
          this.headers2 = this.headers.map((category: string) => {
            return { colname: category, sortorder: category === colName ? sort : 'nosort' };
          });
        }

        let headercount = this.headers.length;
        const nonAdditionalHeaders = (this.headers || []).filter((header: string) => !this.isAdditionalColumnHeader(header));
        const rowHeaderScope = nonAdditionalHeaders.length > 0 ? nonAdditionalHeaders : (this.headers || []);
        const rowHeaderScopeSet = new Set(rowHeaderScope);
        let CategerioesCount = this.categories.length;
        this.headers = this.headers.filter((x: any) => {
          let count = 0;
          chartData.forEach((y: any) => {
            if (x == y[columnName]) {
              if (y['Label'] == null || y['Label'] == undefined || y['Label'] == "NA" || (y['isMultiPunch'] == 1 && y['Label'] == 0) ) {
                count = count + 1;
              }
            }
          });
          if (count != CategerioesCount)
            return x;
        });

        headercount = rowHeaderScope.length;
        this.categories = this.categories.filter((x: any) => {
          let count = 0;
          chartData.forEach((y: any) => {
            if (x == y[RowName] && rowHeaderScopeSet.has(y[columnName])) {
              if (y['Label'] == null || y['Label'] == "NA" || y['Label'] == undefined || (y['isMultiPunch'] == 1 && y['Label'] == 0) ) {
                count = count + 1;
              }
            }
          });
          if (count != headercount)
            return x;
        });

        this.categories2 = this.categories.map((category: string) => {
          return { colname: category, sortorder: category === colName ? sort : 'nosort' };
        });

      const hasManualColumnSort = this.properties.selectedColumn != undefined && this.properties.selectedColumn !== '';

      if (hasManualColumnSort && !skipSorting) {
        if (this.properties.selectedsorting == "asc") {
          this.sortTableDataAscending(this.properties.selectedColumn)
        }
        else {
          this.sortTableDataDescending(this.properties.selectedColumn)
        }
      } else if (!skipSorting) {
        const defaultAdditionalSort = this.getDefaultAdditionalColumnSortConfig();
        if (defaultAdditionalSort) {
          this.sortCategoriesByAdditionalColumn(defaultAdditionalSort.columnHeader, defaultAdditionalSort.sortOrder);
        }
      }

      if (this.properties.sort == "ascending") {
        this.headers.sort((a: any, b: any) => a.localeCompare(b));  // Sorts alphabetically
      } else if (this.properties.sort == "descending") {
        this.headers.sort((a: any, b: any) => b.localeCompare(a));  // Sorts in reverse alphabetical order
      }
    }

    // Apply additional-column placement at the end so hide/sort logic does not override it.
    this.reorderHeadersForAdditionalColumn();

    this.headers1 = this.categories.slice(start, end);


    // if (!this.properties.Transpose) {
    //   const columnIndex = this.headers.indexOf(colName);
    //   if (columnIndex !== -1) {

    //     if (this.headers2[columnIndex].sortorder === 'asc') {
    //       this.sortTableDataAscending(colName);
    //     } else if (this.headers2[columnIndex].sortorder === 'desc') {
    //       this.sortTableDataDescending(colName);
    //     }
    //   }
    // }


  }
  getAdditionalColumnCellColor(row: any, col: any): string {
    if (!this.additionalColumnInfos || this.additionalColumnInfos.length === 0) return '';

    const targetHeader = this.properties?.Transpose1 ? row : col;
    const isAdditionalCol = this.additionalColumnInfos.some((info) => info.columnHeader === targetHeader);

    if (!isAdditionalCol) return '';

    let matchingItem: any;
    if (this.properties?.Transpose1) {
      matchingItem = this.chartMainData.find((item: any) =>
        item['Category Name'] === col && item['Series Name'] === row
      );
    } else {
      matchingItem = this.chartMainData.find((item: any) =>
        item['Category Name'] === row && item['Series Name'] === col
      );
    }

    return matchingItem?.additionalColumnColor || '';
  }
  HideNA(uniqueCategoryNames: any) {
    let columnName = 'Series Name';
    let RowName = 'Category Name';
    if (this.properties.Transpose1) {
      columnName = 'Category Name';
      RowName = 'Series Name';
    }
    this.headers = this.headers.filter((x: any) => {
      let count = 0;
      this.chartMainData.forEach((y: any) => {
        if (x == y[columnName]) {
          if (y['Label'] == null || y['Label'] == "NA" || y['Label'] == undefined || (y['isMultiPunch'] == 1 && y['Label'] == 0) ) {
            count = count + 1;
          }
        }
      });
      if (count != this.headers.length)
        return x;
    });

    let categories = this.categories.filter((x: any) => {
      let count = 0;
      this.chartMainData.forEach((y: any) => {
        if (x == y[RowName]) {
          if (y['Label'] == null || y['Label'] == "NA" || y['Label'] == undefined || (y['isMultiPunch'] == 1 && y['Label'] == 0)) {
            count = count + 1;
          }
        }
      });
      if (count != this.categories.length)
        return x;
    });

    const common = uniqueCategoryNames.filter((value: any) => categories.includes(value));

    return common;
  }

  SortHideNA(uniqueCategoryNames: any, HideNAcategories: any) {
    const common = uniqueCategoryNames.filter((value: any) => HideNAcategories.includes(value));
    return common;
  }

 //BIPS sorting is not working with these changes. 
 //The bug IDs mentioned in the commit are linked to CT and BA, not Snapshot. 
 // However, this component used in Snapshot Only. 
  sortTableDataAscending1(seriesName: string): void {
    let column = 'Series Name';
    let row = 'Category Name';
    if (this.properties.Transpose1) {
      column = 'Category Name';
      row = 'Series Name';
    }
    const filteredData = this.chartMainData.filter((item: { [x: string]: string; }) => item[column] === seriesName);
    if (filteredData.length > 0) {
      const groupedByBrand: { [key: string]: any[] } = {};
      const brandOrderMap: { [key: string]: number } = {};
      let orderIndex = 0;

      this.chartMainData.forEach((item: any) => {
        if (item[column] === seriesName) {
          const categoryName = item[row];
          // Extract brand name from pattern like "Brand Affinity - PARENT BRAND : Colgate : Bottom3Box"
          const brandMatch = categoryName.match(/:\s*([^:]+)\s*:/);
          const brandKey = brandMatch ? brandMatch[1].trim() : categoryName;

          if (!groupedByBrand[brandKey]) {
            groupedByBrand[brandKey] = [];
            brandOrderMap[brandKey] = orderIndex++;
          }
          groupedByBrand[brandKey].push(item);
        }
      });

      const brandOrder = Object.keys(groupedByBrand).sort((a, b) => brandOrderMap[a] - brandOrderMap[b]);
      const sortedValuesArray: any[] = [];
      brandOrder.forEach((brandKey: string) => {
        const brandGroup = groupedByBrand[brandKey];
        const sortedGroup = _.orderBy(brandGroup,
          [(item) => item['Rounded Value'] === 'NA' ? Infinity : item['Rounded Value']],
          ['asc']);
        sortedValuesArray.push(...sortedGroup);
      });
      // Update the original array with the sorted values for the specified seriesName
      let sortedIndex = 0;
      let sortedData = [];
      sortedData = this.chartMainData.map((item: { [x: string]: string; }) => {
        if (item[column] === seriesName) {
          const sortedItem = sortedValuesArray[sortedIndex];
          sortedIndex++;
          return sortedItem || item;
        }
        return item;
      });
      const extractedCategoryNames: string[] = sortedData
        .filter((item: { [x: string]: string }) => item[column] === seriesName)
        .map((item: { [x: string]: string }) => item[row]);

      const uniqueCategoryNames: string[] = Array.from(new Set(extractedCategoryNames));

      // Use the sorted uniqueCategoryNames directly as it already has the correct sorted order
      // Only filter to keep existing categories if needed
     // if (this.properties.hideNA) {
        // Filter uniqueCategoryNames to only include items that should be visible
        const oldCategories = this.categories;
        this.categories = uniqueCategoryNames.filter((cat: any) => oldCategories.includes(cat));
      // } else {
      //   this.categories = uniqueCategoryNames;
      // }

      this.categories2 = this.categories.map((category: string) => {
        return { colname: category };
      });


      this.chartMainData = [];
      this.chartMainData = sortedData;
      this.selectedColumn = seriesName;
      this.selectedascending = "asc";
      this.properties.selectedColumn = seriesName;
      this.properties.selectedsorting = "asc";
      for (let i = 0; i < this._configService.allPageOutputDataWithoutTrend[0].length; i++) {
        if (this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name) {
          this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties = JSON.stringify(this.properties);
        }
      }
      // Refresh the view with sorted data (skipSorting=true to prevent recursion, preserveCategories=true to keep sorted order)
      this.getData(this.chartMainData, 0, this.itemsPerPage, seriesName, 'asc', true, true);
    }
    //  else{
    //   if(this.properties.hideNA){
    //     this.HideNA2();
    //   }
    //   else{
    //     this.Transpose();
    //   }
    //  }
  }

  sortTableDataAscending(seriesName: string, isUserAction: boolean = false): void {
    // Toggle: clicking the active ascending sort again resets to original order
    if (isUserAction && this.properties?.selectedColumn === seriesName && this.properties?.selectedsorting === 'asc') {
      this.resetSort();
      return;
    }
    // Capture original state before the first sort
    if (!this.originalChartMainData) {
      this.originalChartMainData = _.cloneDeep(this.chartMainData);
    }
    if (!this.originalCategories) {
      this.originalCategories = [...this.categories];
    }
    let column='Series Name';
    let row='Category Name';
    if (this.properties.Transpose1) {
      column='Category Name';
      row='Series Name';
    }
    const filteredData = this.chartMainData.filter((item: { [x: string]: string; }) => item[column] === seriesName);
      if(filteredData.length > 0){
        //const sortedValuesArray = _.orderBy(filteredData, 'Rounded Value', 'asc');
        const sortedValuesArray =  _.orderBy(filteredData,
          [(item) => item['Rounded Value'] === 'NA' ? -Infinity : item['Rounded Value']],
          ['asc']);
        // Update the original array with the sorted values for the specified seriesName
        let sortedIndex = 0;
        let sortedData = [];
        sortedData = this.chartMainData.map((item: { [x: string]: string; }) => {
          if (item[column] === seriesName) {
            const sortedItem = sortedValuesArray[sortedIndex];
            sortedIndex++;
            return sortedItem || item;
          }
          return item;
        });
        const extractedCategoryNames: string[] = sortedData
          .filter((item: { [x: string]: string }) => item[column] === seriesName)
          .map((item: { [x: string]: string }) => item[row]);



        const uniqueCategoryNames: string[] = Array.from(new Set(extractedCategoryNames));
        let categories:any
        // if(this.properties.hideNA)
        //   categories = this.HideNA(uniqueCategoryNames);
        // else
        //   categories = uniqueCategoryNames;
        this.categories = this.SortHideNA(uniqueCategoryNames,this.categories);

        this.categories2 = this.categories.map((category: string) => {
          return { colname: category };
        });


        // Keep IsAttributeRaw records pinned to the front
        const attributeRawItems = sortedData.filter((item: any) => item['IsAttributeRaw'] === true);
        const regularItems = sortedData.filter((item: any) => item['IsAttributeRaw'] !== true);
        sortedData = [...attributeRawItems, ...regularItems];

        // Pin IsAttributeRaw categories to the front regardless of which column was sorted
        const attributeRawCats = [...new Set(attributeRawItems.map((item: any) => item[row]))] as string[];
        const regularCats = this.categories.filter((cat: any) => !attributeRawCats.includes(cat));
        this.categories = [...attributeRawCats, ...regularCats];
        this.categories2 = this.categories.map((category: string) => {
          return { colname: category };
        });

        this.chartMainData= [];
        this.chartMainData = sortedData;
        this.selectedColumn = seriesName;
        this.selectedascending ="asc";
        this.properties.selectedColumn = seriesName;
        this.properties.selectedsorting ="asc";
        for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
          if(this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
            this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties=JSON.stringify(this.properties);
          }
        }
     }
    //  else{
    //   if(this.properties.hideNA){
    //     this.HideNA2();
    //   }
    //   else{
    //     this.Transpose();
    //   }
    //  }
  }

  Transpose() {
    if (this.properties.Transpose1) {
      this.headers = this.extractUniqueValues(this.chartMainData, 'Category Name');
      this.categories = this.extractUniqueValues(this.chartMainData, 'Series Name');
    } else {
      this.headers = this.extractUniqueValues(this.chartMainData, 'Series Name');
      this.categories = this.extractUniqueValues(this.chartMainData, 'Category Name');
    }
  }

  sortTableDataDescending1(seriesName: string): void {
    let column = 'Series Name';
    let row = 'Category Name';
    if (this.properties.Transpose1) {
      column = 'Category Name';
      row = 'Series Name';
    }
    const filteredData = this.chartMainData.filter((item: { [x: string]: string; }) => item[column] === seriesName);
    if (filteredData.length > 0) {
      const groupedByBrand: { [key: string]: any[] } = {};
      const brandOrderMap: { [key: string]: number } = {};
      let orderIndex = 0;

      this.chartMainData.forEach((item: any) => {
        if (item[column] === seriesName) {
          const categoryName = item[row];
          // Extract brand name from pattern like "Brand Affinity - PARENT BRAND : Colgate : Bottom3Box"
          const brandMatch = categoryName.match(/:\s*([^:]+)\s*:/);
          const brandKey = brandMatch ? brandMatch[1].trim() : categoryName;

          if (!groupedByBrand[brandKey]) {
            groupedByBrand[brandKey] = [];
            brandOrderMap[brandKey] = orderIndex++;
          }
          groupedByBrand[brandKey].push(item);
        }
      });

      const brandOrder = Object.keys(groupedByBrand).sort((a, b) => brandOrderMap[a] - brandOrderMap[b]);
      const sortedValuesArray: any[] = [];
      brandOrder.forEach((brandKey: string) => {
        const brandGroup = groupedByBrand[brandKey];
        const sortedGroup = _.orderBy(brandGroup,
          [(item) => item['Rounded Value'] === 'NA' ? -Infinity : item['Rounded Value']],
          ['desc']);
        sortedValuesArray.push(...sortedGroup);
      });

      // Update the original array with the sorted values for the specified seriesName
      let sortedIndex = 0;
      let sortedData = [];
      sortedData = this.chartMainData.map((item: { [x: string]: string; }) => {
        if (item[column] === seriesName) {
          const sortedItem = sortedValuesArray[sortedIndex];
          sortedIndex++;
          return sortedItem || item;
        }
        return item;
      });
      const extractedCategoryNames: string[] = sortedData
        .filter((item: { [x: string]: string }) => item[column] === seriesName)
        .map((item: { [x: string]: string }) => item[row]);

      const uniqueCategoryNames: string[] = Array.from(new Set(extractedCategoryNames));

      // Use the sorted uniqueCategoryNames directly as it already has the correct sorted order
      // Only filter to keep existing categories if needed
    //  if (this.properties.hideNA) {
        // Filter uniqueCategoryNames to only include items that should be visible
        const oldCategories = this.categories;
        this.categories = uniqueCategoryNames.filter((cat: any) => oldCategories.includes(cat));
      // } else {
      //   this.categories = uniqueCategoryNames;
      // }
      this.categories2 = this.categories.map((category: string) => {
        return { colname: category };
      });
      this.chartMainData = [];
      this.chartMainData = sortedData;
      this.selectedColumn = seriesName;
          this.selectedascending ="desc";
      this.properties.selectedColumn = seriesName;
          this.properties.selectedsorting ="desc";
          for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
            if(this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
              this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties=JSON.stringify(this.properties);
        }
      }
      // Refresh the view with sorted data (skipSorting=true to prevent recursion, preserveCategories=true to keep sorted order)
      this.getData(this.chartMainData, 0, this.itemsPerPage, seriesName, 'desc', true, true);
    }
    //  else{
    //   if(this.properties.hideNA){
    //       this.HideNA2();
    //   }
    //   else{
    //     this.Transpose();
    //   }
    //  }
  }

  sortTableDataDescending(seriesName: string, isUserAction: boolean = false): void {
    // Toggle: clicking the active descending sort again resets to original order
    if (isUserAction && this.properties?.selectedColumn === seriesName && this.properties?.selectedsorting === 'desc') {
      this.resetSort();
      return;
    }
    // Capture original state before the first sort
    if (!this.originalChartMainData) {
      this.originalChartMainData = _.cloneDeep(this.chartMainData);
    }
    if (!this.originalCategories) {
      this.originalCategories = [...this.categories];
    }
    let column='Series Name';
    let row='Category Name';
    if (this.properties.Transpose1) {
      column='Category Name';
      row='Series Name';
    }
    const filteredData = this.chartMainData.filter((item: { [x: string]: string; }) => item[column] === seriesName);
      if(filteredData.length > 0){
         // const sortedValuesArray = _.orderBy(filteredData, 'Rounded Value', 'desc');
         const sortedValuesArray =  _.orderBy(filteredData,
          [(item) => item['Rounded Value'] === 'NA' ? Number.NEGATIVE_INFINITY : item['Rounded Value']],
          ['desc']);

          // Update the original array with the sorted values for the specified seriesName
          let sortedIndex = 0;
          let sortedData = [];
          sortedData = this.chartMainData.map((item: { [x: string]: string; }) => {
            if (item[column] === seriesName) {
              const sortedItem = sortedValuesArray[sortedIndex];
              sortedIndex++;
              return sortedItem || item;
            }
            return item;
          });
          const extractedCategoryNames: string[] = sortedData
            .filter((item: { [x: string]: string }) => item[column] === seriesName)
            .map((item: { [x: string]: string }) => item[row]);



          const uniqueCategoryNames: string[] = Array.from(new Set(extractedCategoryNames));
          let categories:any
          // if(this.properties.hideNA)
          //   categories = this.HideNA(uniqueCategoryNames);
          // else
          //   categories = uniqueCategoryNames;
          this.categories =  this.SortHideNA(uniqueCategoryNames,this.categories);
          this.categories2 = this.categories.map((category: string) => {
            return { colname: category };
          });
          // Keep IsAttributeRaw records pinned to the front
          const attributeRawItems = sortedData.filter((item: any) => item['IsAttributeRaw'] === true);
          const regularItems = sortedData.filter((item: any) => item['IsAttributeRaw'] !== true);
          sortedData = [...attributeRawItems, ...regularItems];

          // Pin IsAttributeRaw categories to the front regardless of which column was sorted
          const attributeRawCats = [...new Set(attributeRawItems.map((item: any) => item[row]))] as string[];
          const regularCats = this.categories.filter((cat: any) => !attributeRawCats.includes(cat));
          this.categories = [...attributeRawCats, ...regularCats];
          this.categories2 = this.categories.map((category: string) => {
            return { colname: category };
          });

          this.chartMainData = [];
          this.chartMainData = sortedData;
          this.selectedColumn = seriesName;
          this.selectedascending ="desc";
          this.properties.selectedColumn = seriesName;
          this.properties.selectedsorting ="desc";
          for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
            if(this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
              this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties=JSON.stringify(this.properties);
            }
          }
     }
    //  else{
    //   if(this.properties.hideNA){
    //       this.HideNA2();
    //   }
    //   else{
    //     this.Transpose();
    //   }
    //  }
  }


  resetSort(): void {
    if (this.originalChartMainData) {
      this.chartMainData = _.cloneDeep(this.originalChartMainData);
    }
    if (this.originalCategories) {
      this.categories = [...this.originalCategories];
      this.categories2 = this.categories.map((category: string) => ({ colname: category, sortorder: 'nosort' }));
    }
    this.originalChartMainData = null;
    this.originalCategories = null;
    this.selectedColumn = '';
    this.selectedascending = '';
    this.properties.selectedColumn = undefined;
    this.properties.selectedsorting = undefined;
    for (let i = 0; i < this._configService.allPageOutputDataWithoutTrend[0].length; i++) {
      if (this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name) {
        this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties = JSON.stringify(this.properties);
      }
    }
    this.getData(this.chartMainData, 0, this.itemsPerPage, '', 'nosort', true, true);
  }

 HideNA2(){
  let columnName='Series Name';
  let RowName='Category Name';
  if (this.properties.Transpose1){
    columnName='Category Name';
    RowName='Series Name';
    }
    let headercount = this.headers.length;
    let CategerioesCount = this.categories.length;
  this.headers= this.headers.filter((x:any)=>{
          let count=0;
          this.chartMainData.forEach((y:any)=>{
                if(x==y[columnName]){
                    if(y['Label']==null || y['Label']=="NA" || y['Label']==undefined){
                        count=count+1;
          }
        }
      });
          if(count!=headercount)
        return x;
    });

    this.categories = this.categories.filter((x: any) => {
      let count = 0;
      this.chartMainData.forEach((y: any) => {
        if (x == y[RowName]) {
          if (y['Label'] == null || y['Label'] == "NA" || y['Label'] == undefined) {
            count = count + 1;
          }
        }
      });
      if (count != CategerioesCount)
        return x;
    });
  }

  /**
  * Mimics C# Math.Round(value, decimals) behavior
  * - Uses Banker's rounding (round to even)
  * - Returns a string (like JavaScript's .toFixed())
  */
  private toFixedLikeCSharp(value: number, decimals: number = 0): string {
    const factor = Math.pow(10, decimals);
    const scaled = value * factor;
    const fraction = scaled - Math.floor(scaled);

    let rounded: number;

    if (fraction > 0.5) {
      rounded = Math.ceil(scaled);
    } else if (fraction < 0.5) {
      rounded = Math.floor(scaled);
    } else {
      // Exactly halfway (.5) → round to even
      const floor = Math.floor(scaled);
      rounded = (floor % 2 === 0) ? floor : floor + 1;
    }

    const result = rounded / factor;
    return result.toFixed(decimals);
  }

  isAttributeRawColumn(col: string): boolean {
    return this.chartMainData.some((item: any) => item['Series Name'] === col && item['IsAttributeRaw'] === true);
  }

  getAttributeRawColumnLeft(col: string): string {
    const attributeRawHeaders = this.headers.filter((h: string) =>
      this.chartMainData.some((item: any) => item['Series Name'] === h && item['IsAttributeRaw'] === true)
    );
    const index = attributeRawHeaders.indexOf(col);
    return `${(index + 1) * 150}px`;
  }

  getAttributeRawTooltip(col: string): string {
    const item = this.chartMainData.find((d: any) => d['Series Name'] === col && d['IsAttributeRaw'] === true);
    return item?.tooltipText ?? '';
  }

  getDataCell(row: any, col: any) {

    const cacheKey = `${row}_${col}`;

    // Check if the processed data for the cell is already cached
    //if (this.dataCellCache[cacheKey]) {
    //  return this.dataCellCache[cacheKey];
    //}

    let dataArray: any[] = [];
    let matchingItems;
    if (this.isOutput) {
      if (this.properties.Transpose1) {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }
    else {
      if (this.properties.Transpose1) {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }

    // Process and store the cell data (dedupe to avoid the reference column rendering twice when Index is enabled)
    matchingItems = this.dedupeMatchingItems(matchingItems);
    matchingItems.forEach((item: any) => {
      let value = "";
      const sampleSize = Number(item['Sample size']);
      const isNonSuperAdmin = this._configService?.userRole != 'superadmin';
      const threshold = this._configService?.ISthreshold;
      const isLowSample = isNonSuperAdmin && !isNaN(sampleSize) && threshold != null && sampleSize <= threshold;

      if (this.properties.datalabelStyle == "default" || this.properties.datalabelStyle == "datalabel") {
        if (isLowSample && sampleSize > 0) {
          value = 'I/S';
        } else {
          const label = item['Label'];
          const isNA = (label == "" || label == "NA") && label != "0";
          if (isNA) {
            value = 'NA';
          } else {
            const num = Number(label);
            const fixed = this.toFixedLikeCSharp(num, this.properties.decimalRoundOff);
            const parsed = parseFloat(fixed);
            value = (parsed === 0 ? '0' : fixed) + (item['isPercentage'] ? '%' : '');
          }
        }
      } else if (this.properties.datalabelStyle == "change") {
        if (isLowSample) {
          value = 'I/S';
        } else {
          value = item['Rounded Value'] == "" ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color:black">' + '(' + item["Change value vs PY"] + ')' + '</span>';
        }
      } else if (this.properties.datalabelStyle == "significance + changeVs") {
        if (isLowSample) {
          value = 'LS';
        } else {
          let sig = item['Significance'];
          let sColor = sig > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : '');
          let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');
          value = item['Rounded Value'] == "" ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color:black">' + '(' + item["Change value vs PY"] + ')' + '</span>' + '<span style="color: ' + sColor + '">' + s + '</span>';
        }
      } else if (this.properties.datalabelStyle == "ls") {
        // Legacy 'ls' display mode, now respect role + threshold instead of 9000 magic number
        value = item['Rounded Value'] == "" ? 'NA' : (isLowSample ? 'LS' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : ''));
      } else if (this.properties.datalabelStyle == "significance") {
        if (isLowSample) {
          value = 'I/S';
        } else {
          let sig = item['Significance'];
          let sColor = sig > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : '');
          let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');
          value = item['Rounded Value'] == 0 ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color: ' + sColor + '">' + s + '</span>';
        }
      } else if (this.properties.datalabelStyle == "significance2") {
        if (isLowSample) {
          value = 'I/S';
        } else {
          let sig2 = item['Significance2'];
          let sig = item['Significance'];
          let sColor = sig > 0 ? this.tableService.highSignificance : this.tableService.lowSignificance;
          let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');
          let changeTextColor = sig2 > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : 'black');
          value = item['Rounded Value'] == "" ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color:' + changeTextColor + '">(' + item["Change value vs PY"] + ')</span>' + '<span style="color: ' + sColor + '">' + s + '</span>';
        }
      }
      dataArray.push(value);
    });

    // Cache the processed cell data
    this.dataCellCache[cacheKey] = dataArray;

    //return dataArray;
    return this.sanitizer.bypassSecurityTrustHtml(dataArray.join(''));
  }

  getBarColor(row: any, col: any): string {
  const seriesName = this.properties.Transpose1 ? row : col;
  
  if (Object.keys(this.globalColorMap).length === 0) {
    this.globalColorMap = this._configService.getGlobalColorMap();
  }

  if (this.globalColorMap && this.globalColorMap[seriesName]) {
    return this.globalColorMap[seriesName];
  }

  const prefixedKey = `Brands|${seriesName}`;
  if (this.globalColorMap && this.globalColorMap[prefixedKey]) {
    return this.globalColorMap[prefixedKey];
  }

  return 'rgb(77, 144, 255)';
}


  getChangeVsCell(row: any, col: any) {

    const cacheKey = `${row}_${col}`;

    // Check if the processed data for the cell is already cached
    //if (this.dataCellCache[cacheKey]) {
    //  return this.dataCellCache[cacheKey];
    //}

    let dataArray: any[] = [];
    let matchingItems;
    if (this.isOutput) {
      if (this.properties.Transpose1) {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }
    else {
      if (this.properties.Transpose1) {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }

    // Process and store the cell data (dedupe to avoid the reference column rendering twice when Index is enabled)
    matchingItems = this.dedupeMatchingItems(matchingItems);
    matchingItems.forEach((item: any) => {
      let value = "";
      if (this._configService.isIndexSelected == false) {
        if (this.SigValue != "None") {
          value = (item['Change value vs PY'] == null || item['Change value vs PY'] == "" || item['Change value vs PY'] == "NA") && item['Change value vs PY'] != 0 ? '(NA)' : "(" + parseFloat(Number(item['Change value vs PY'] * 100).toFixed(1)) + "%)";
        }
      }
      else if (this._configService.isIndexSelected == true) {
        value = (item['ValueForIndex'] == null || item['ValueForIndex'] == "" || item['ValueForIndex'] == "NA") && item['ValueForIndex'] != 0 ? '(NA)' : "(" + parseFloat(Number(item['ValueForIndex']).toFixed(1)) + ")";
      }
      dataArray.push(value);
    });

    // Cache the processed cell data
    this.dataCellCache[cacheKey] = dataArray;

    //return dataArray;
    return this.sanitizer.bypassSecurityTrustHtml(dataArray.join(''));
  }

  getSigCell(row: any, col: any) {

    const cacheKey = `${row}_${col}`;

    // Check if the processed data for the cell is already cached
    //if (this.dataCellCache[cacheKey]) {
    //  return this.dataCellCache[cacheKey];
    //}

    let dataArray: any[] = [];
    let matchingItems;
    if (this.isOutput) {
      if (this.properties.Transpose1) {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }
    else{
      if (this.properties.Transpose1) {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.tableData[0].data.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }
    let color:any;
    // Process and store the cell data (dedupe to avoid the reference column rendering twice when Index is enabled)
    matchingItems = this.dedupeMatchingItems(matchingItems);
    matchingItems.forEach((item: any) => {
      let value = "";
      if (this._configService.isIndexSelected == false) {
        if (this.SigValue != "None") {
          color = item['Significance_Value'] < this.Sig_LowerLimt ? 'red' : (item['Significance_Value'] > this.Sig_UpperLimt ? 'green' : 'black');
        }
      }
      else {
        color = this._configService.CheckIndexColoring(String(item['ActualIndexValue']));
      }
      dataArray.push(color);
    });

    // Cache the processed cell data
    this.dataCellCache[cacheKey] = dataArray;

    //return dataArray;
    return (dataArray.join(''));
  }

  // Removes exact-duplicate data points (e.g. the reference column repeated once for its own value and once as the 100 index base) while keeping genuine multi-punch entries
  private dedupeMatchingItems(items: any[]): any[] {
    const seen = new Set<string>();
    return items.filter((item: any) => {
      const key = `${item['Rounded Value']}|${item['ValueForIndex']}|${item['ActualIndexValue']}|${item['Sample size']}|${item['Change value vs PY']}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }

  private extractUniqueValues(chartData: any, propertyName: string): string[] {
    return [...new Set(
      chartData
        .map((item: any) => item[propertyName])
        .flat()
        .filter((value: undefined) => value !== undefined)
    )] as string[];
  }



  customization() {
  const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("Table", this._customSnapshotService.selectedSnapshotType?.name,cohortType));
  }
  commonfunc(event: any, customization: string, options: any) {
    let property;

    this.tableService.commonFunc(customization, event, this.properties, this.customTable, this.headerElement);
    this.itemsPerPage = this.properties.pagination ? this.categories.length : 10;
    this.getData(this.tableData, this.start, this.end, " ", this.sorting);

  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.tableService.applycustomization(event, item, this.properties)
    localStorage.setItem("properties", JSON.stringify(this.properties));
    //this.plotChart('chart-container' + this.id, this.jsondata['data'], this.chartproperties);
    //this.properties.ColumnHeaderFontSize="0.5em";
  }

  hexToRgb(hex: string): string {
    // Remove the '#' if it's included
    hex = hex.replace('#', '');

    // Convert the hex to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `${r}, ${g}, ${b}`; // Returns rgb(r, g, b)
  }

  GetRowName(name: any) {
    if (!this.isOutput) {
      if (this._customSnapshotService.selectedSnapshotType.name == "Multiple Markets")
        return name.replace(/Brand/g, "Market")
      else
        return name;
    }
    else {
      return name;
    }
  }

  userselectedproperties() {

    this.data["properties"][0] = this.properties;

    return JSON.stringify(this.data).toString();
  }

  getMarginForScroll() {
    let tblRef: any = document.getElementById('table-scroll');
    if (tblRef != null) {
      let theadRef = tblRef.getElementsByTagName('thead');
      let fixedcolRef = tblRef.getElementsByClassName('FreezedColumn');
      let xscroll = fixedcolRef[0].clientWidth;
      if (this.properties?.Transpose1 != undefined) {
        fixedcolRef = tblRef.getElementsByTagName('tbody')[0].firstChild.clientWidth
        xscroll = Number(fixedcolRef) % this.categories.length + 1;
      }
      if (theadRef != null && theadRef.length > 0) {
        const frozenColCount = this.headers.filter((h: string) =>
          this.chartMainData.some((item: any) => item['Series Name'] === h && item['IsAttributeRaw'] === true)
        ).length;
        const totalFrozenWidth = 150 + (frozenColCount * 150);
        return `${theadRef[0].clientHeight}px 0 0 ${totalFrozenWidth}px`;
      }
    }
    return 0;
  }

  index = -1;

  private isLowSample(sampleSize: any): boolean {
    const s = Number(sampleSize);
    if (isNaN(s)) return false;
    return (this._configService?.userRole != 'superadmin') && (this._configService?.ISthreshold != null) && s <= this._configService.ISthreshold;
  }
  shouldHideSignificance(cellValue: any): boolean {
    if (!cellValue) return true;

    // Convert the cell value to string and check for special values
    const cellString = cellValue.toString();

    // Check if the cell contains I/S, NA, or LS (case insensitive)
    return cellString.includes('I/S') ||
      cellString.includes('NA') ||
      cellString.includes('LS') ||
      cellString.includes('i/s') ||
      cellString.includes('na') ||
      cellString.includes('ls');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}


